import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Stripe as StripeConstructor } from '@stripe/stripe-js';
import App from './App.tsx';
import './index.css';
import './styles/stripe-override.css';
import './styles/hljs-theme.css';

// Remove duplicate Stripe script loading since it's already loaded by @stripe/stripe-js
declare global {
  interface Window {
    Stripe?: (key: string) => StripeConstructor;
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
